<template>
  <!-- 课程悬浮 -->
  <div class="course-suspension-container">
    <!-- 课程封面 -->
    <img class="course-cover" :src="courseInfo.courseScheduleImg" />
    <div class="course-info-box">
      <div class="info-top">
        <!-- 课程类型 -->
        <img class="course-type" :src="Number(courseInfo.classType) === 0 ? require('../assets/img/live_type.png') : require('../assets/img/record_type.png')" alt="">
        <!-- 课程名称 -->
        <div class="course-name">{{ courseInfo.courseScheduleName }}</div>
        <!-- 关闭按钮 -->
        <van-icon name="cross" class="tips-close" @click="closeCourseTips" v-if="showSendBtn" />
      </div>
      <div class="info-bottom">
        <!-- 老师名称 -->
        <div class="teacher-name">{{ courseInfo.teacherName }}</div>
        <!-- 课程价格 -->
        <div class="course-price">¥<span class="num">{{ courseInfo.courseSellPrice }}</span></div>
        <div class="send-btn" v-if="showSendBtn" @click="clickSend">发给客服</div>
      </div>
    </div>
  </div>
</template>

<script>
// import merge from 'webpack-merge'
export default {
  props: {
    showSendBtn: {
      type: Boolean,
      default: false
    },
    courseInfo: {
      default: () => {}
    }
  },
  created () {
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  methods: {
    // 将路由中的课程信息参数删掉
    updateUrl () {
      let queryObj = this.$route.query
      if (queryObj.courseScheduleId) {
        delete queryObj.courseScheduleId
        delete queryObj.sellCourseScheduleId
        delete queryObj.classType
        delete queryObj.courseScheduleName
        delete queryObj.courseScheduleImg
        delete queryObj.teacherName
        delete queryObj.courseSellPrice
      }
      let newQuery = ''
      Object.keys(queryObj).forEach(key => {
        console.log('key', key)
        newQuery = newQuery + (newQuery ? ('&' + key + '=' + queryObj[key]) : (key + '=' + queryObj[key]))
      })
      // 获取当前URL
      var url = window.location.href
      // 拼接新的URL
      var newUrl = url.split('?')[0] + '?' + newQuery
      // 修改地址栏URL
      history.pushState(null, null, newUrl)
    },
    // 点击发送
    clickSend () {
      let queryObj = {
        ...this.$route.query
      }
      this.updateUrl()
      this.$router.push({
        name: 'Service',
        query: {
          ...queryObj
        }
      })
    },
    // 点击关闭
    closeCourseTips () {
      // this.showCourseCard = false
      this.updateUrl()
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.course-suspension-container{
  display: flex;
  padding: 10px 16px 10px 10px;
  border-radius: 8px;
  box-sizing: border-box;
  background-color: #fff;
  .course-cover{
    width: 16vw;
    height: 16vw;
    border-radius: 8px;
  }
  .course-info-box{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    width: 0;
    margin-left: 10px;
    .info-top{
      display: flex;
      align-items: center;
      .course-type{
        height: 16px;
      }
      .course-name{
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0 20px 0 6px;
      }
    }
    .info-bottom{
      position: relative;
      .teacher-name{
        color: #666;
        font-size: 12px;
        margin-bottom: 9px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .course-price{
        color: #FF6D3E;
        font-size: 12px;
        font-weight: 500;
        .num{
          font-weight: 400;
          font-size: 16px;
        }
      }
      .send-btn{
        position: absolute;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        background: linear-gradient( 99deg, #FFAF3E 0%, #FF4242 100%);
        color: #fff;
        width: 80px;
        height: 26px;
        border-radius: 13px;
        cursor: pointer;
      }
    }
  }
}
// // 课程悬浮动画效果
// @keyframes courseMove
// {
//   from {
//     transform: translateY(60%);
//     opacity: 0;
//   }
//   to {
//     transform: translateY(-100%);
//     opacity: 1;
//   }
// }
// @-moz-keyframes courseMove
// {
//   from {
//     transform: translateY(60%);
//     opacity: 0;
//   }
//   to {
//     transform: translateY(-100%);
//     opacity: 1;
//   }
// }
// @-webkit-keyframes courseMove
// {
//   from {
//     transform: translateY(60%);
//     opacity: 0;
//   }
//   to {
//     transform: translateY(-100%);
//     opacity: 1;
//   }
// }
// @-o-keyframes courseMove
// {
//   from {
//     transform: translateY(60%);
//     opacity: 0;
//   }
//   to {
//     transform: translateY(-100%);
//     opacity: 1;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/CourseSuspension.vue